import React from 'react';
import styled from 'styled-components';
import { Switch, Route } from 'react-router-dom';
import routes from '../../routes';

interface Props {}

const Container = styled.div`
  height: 100%;
  width: 100%;
  overflow: auto;
`;

const Runs: React.FunctionComponent<Props> = () => {
  return (
    <Container>
      <Switch>
        {routes
          .filter((route) => route.component)
          .map((route) => (
            <Route key={route.path} path={route.path} component={route.component} />
          ))}
      </Switch>
    </Container>
  );
};

export default Runs;
